import Link from "next/link";
import { prefix } from "../../utils/utils";
export const ChipNavButton = ({ onClick, text, iconLeft, iconRight, icon }) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-x-4 rounded-xxxs px-8 py-6 media-hover:hover:cursor-pointer bg-gray-350 text-gray-900 border border-solid border-gray-350 media-hover:hover:bg-gray-200 media-hover:hover:border-gray-350 duration-300`}
      aria-label={text || ""}
    >
      {iconLeft && icon}
      {text && (
        <span className="text-xxxs font-medium tracking-05">{text}</span>
      )}
      {iconRight && icon}
    </button>
  );
};

export const ChipNavLinkInternal = ({
  link,
  text,
  iconLeft,
  iconRight,
  icon,
  onClick,
}) => {
  return (
    <Link
      href={prefix(link)}
      as={prefix(link)}
      onClick={onClick}
      target="_self"
      aria-label={text || ""}
      className={`flex items-center gap-x-4 rounded-xxxs px-8 py-6 media-hover:hover:cursor-pointer bg-gray-350 text-gray-900 border border-solid border-gray-350 media-hover:hover:bg-gray-200 media-hover:hover:border-gray-350 duration-300`}
    >
      {iconLeft && icon}
      {text && (
        <span className="text-xxxs font-medium tracking-05">{text}</span>
      )}
      {iconRight && icon}
    </Link>
  );
};

export const ChipNavLinkExternal = ({
  link,
  text,
  iconLeft,
  iconRight,
  icon,
  extraClass,
}) => {
  return (
    <Link
      href={prefix(link)}
      as={prefix(link)}
      target="_blank"
      aria-label={text || ""}
      className={`flex items-center w-fit gap-x-4 rounded-xxxs px-8 py-6 media-hover:hover:cursor-pointer bg-gray-350 text-gray-900 border border-solid border-gray-350 media-hover:hover:bg-gray-200 media-hover:hover:border-gray-350 duration-300 ${extraClass}`}
    >
      {iconLeft && icon}
      {text && (
        <span className="text-xxxs font-medium tracking-05">{text}</span>
      )}
      {iconRight && icon}
    </Link>
  );
};
